<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    type?: 'tablet' | 'mobile' | 'terminal'
    color?: number
    scale?: number
  }>(),
  {
    type: 'tablet',
    color: 50,
    scale: 1
  }
)

const tabletBackground = computed(() => (props.color >= 500 ? 'bg-stone-800' : 'bg-muted'))
</script>
<template>
  <BasePhone v-if="type === 'mobile'" size="md" :scale="scale" class="z-30">
    <div class="h-full overflow-y-auto hideScrollbar">
      <slot></slot>
    </div>
  </BasePhone>
  <div v-if="type === 'terminal'" class="flex flex-col items-center">
    <div class="relative h-[445px] w-[350px] rounded-2xl border bg-muted px-4 py-3 shadow-md">
      <div class="h-full rounded-xl border">
        <slot></slot>
      </div>
    </div>
    <span class="h-[40px] w-[200px] rounded-b-md bg-muted shadow-md"></span>
  </div>

  <div
    v-if="type === 'tablet'"
    class="relative h-full w-full rounded-2xl border px-4 py-3 shadow-md"
    :class="tabletBackground"
  >
    <span class="absolute -top-1 left-16 h-1 w-11 rounded-t-sm border bg-border"></span>
    <span class="absolute -top-1 left-32 h-1 w-6 rounded-t-sm border bg-border"></span>

    <div class="h-full overflow-hidden rounded-xl border">
      <slot></slot>
    </div>
  </div>
</template>
